import { ValidationErrorResponse } from "../../../services/ValidationError";
import {ServicioSpa} from "../../../services/spaServicios";
import {parseCurrency} from "../../../utils/numberUtils";

export interface FormValue {
    wasTouched: boolean,
    isValid: boolean | undefined
}

export interface TextFormValue extends FormValue {
    value: string
}

export interface NumberFormValue extends FormValue {
    value: number
}

export interface FormState {
    nombre: TextFormValue,
    descripcion: TextFormValue,
    precioSesion: TextFormValue,
}

export const initialFormState: FormState = {
    nombre: { value: "", wasTouched: false, isValid: undefined },
    descripcion: { value: "", wasTouched: false, isValid: undefined },
    precioSesion: { value: "0", wasTouched: false, isValid: undefined },
}

export const resetValidStates = (formState: FormState) => {
    Object.keys(formState).forEach(_key => {
        const currentVal: FormValue = (formState as any)[_key] as FormValue;
        (formState as any)[_key] = { ...currentVal, isValid: undefined };
    });
}

export const invalidateStates = (formState: FormState, validationErrorResponse: ValidationErrorResponse) => {
    Object.keys(validationErrorResponse).forEach(errKey => {
        const errKeyStr = errKey as string;
        const currentVal: FormValue = (formState as any)[errKeyStr] as FormValue;
        (formState as any)[errKeyStr] = { ...currentVal, isValid: false };
    })
}

export const servicioSpaAFormState = (servicio: ServicioSpa): FormState => {
    return {
        nombre: {value: servicio?.nombre || '', wasTouched: false, isValid: undefined},
        descripcion: {value: servicio?.descripcion || '', wasTouched: false, isValid: undefined},
        precioSesion: {value: servicio?.precioSesion.toString() || '', wasTouched: false, isValid: undefined},
    };
}

export const formStateAServicioSpa = (id: string, formState: FormState): ServicioSpa => {
    return {
        id,
        nombre: formState.nombre.value,
        descripcion: formState.descripcion.value,
        precioSesion: parseCurrency(formState.precioSesion.value, "$", ","),
    }
}